import {
    getPermiseLoading,
    getPermiseRequest,
    getPermiseSuccess,
    getPermiseReject,
} from "../../actions/profile/getAllPermises";

export const getPermise = (formData) => async (dispatch, getState) => {
    dispatch(getPermiseLoading());
    try {
        const { data } = await getPermiseRequest(formData, getState);
        dispatch(getPermiseSuccess(data))
    } catch (error) {
        dispatch(getPermiseReject(error))
    }
    return Promise.resolve();
};